import styled from 'styled-components';
import { SIZE } from 'common/sizes';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

export const DoughnutBox = styled.div`
    height: 100%;
    align-items: center;
`

export const ChartDoughnutSpacers = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    line-height: normal;
    width: 200px;
    height: 200px;
    z-index: 1;
`

export const GraphicBox = styled.div`
    position: relative;
    width: 200px;
    height: 200px;
`

export const DoughnutBoxLegendRight = styled.div`
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
`

export const DoughnutBoxLegendBottom = styled.div`
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    display: flex;
    flex-direction: column;
`

export const DoughnutBoxInside = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    line-height: normal;
    width: 176px;
    height: 176px;
`

export const DoughnutTextContainer = styled.div`
    position:absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    display: flex;
    flex-flow: column;
    width: 100%;
`

export const DoughnutTextLine1 = styled.span`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
`

export const DoughnutTextLine2 = styled.span`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #8d8d8d;
`

export const Dot = styled.span`
    height: 12px;
    width: 12px;
    border-radius: 50%;
    display: inline-block;
`

export const LegendContainer = styled.div`
    display: block;
`

export const LegendRight = styled.table`
margin: 0px 0px 0px 20px;
`

export const LegendBottom = styled.table`
margin: 20px 0px 0px 0px;
`

export const LegendText = styled.span`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #343434;
    white-space: nowrap;
`
